let validate = (type, value) => {
    var fullnameRegex = /^([A-z]+) ([A-z]+)$/;
    var firstnameRegex = /^([A-z]+){2,}$/;
    var lastnameRegex = /^([A-z]+)$/;
    var emailRegex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var phoneRegex = /^([0-9]{9,16})$/;
    var passwordRegex = /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/;
    var otpRegex = /(\S{5,7})/;
    var serialNumberRegex = /\d{6}-\d{4}-\d{12}-\d{1}-\d{6}/;
    var linkRegex = /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!10(?:\.\d{1,3}){3})(?!127(?:\.​\d{1,3}){3})(?!169\.254(?:\.\d{1,3}){2})(?!192\.168(?:\.\d{1,3}){2})(?!172\.(?:1[​6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1​,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00​a1-\uffff0-9]+-?)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]+-?)*[a-z\u​00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/[^\s]*)?$/i;
    var generalRegex = /(\S+)/;
    var numberRegex = /(\d+)/;
    var businessRegex = /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/;
    var usernameRegex = /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/;
    var priceRegex = /^[1-9]\d{0,7}(?:\.\d{1,4})?$/;
    var accountNumberRegex = /^(\d){8,11}$/;
    var bvnRegex = /^(\d){10,11}$/;




    if (type === "firstname") {

        if (firstnameRegex.test(value)) return true;
        return false;

    }
    else if (type === "username") {

        if (usernameRegex.test(value)) return true;
        return false;

    }
    else if (type === "password checker") {
      var lowerCaseRegex = /(?=.*[a-z])/;
      var upperCaseRegex = /(?=.*[A-Z])/;
      var numberRegex = /(?=.*[0-9])/;
      var symbolRegex = /(?=.*[!@#$%&\*])/;

      if (!lowerCaseRegex.test(value)) {
        return "Password must contain lower case";
      }
      // else if (!upperCaseRegex.test(value)) {
      //   return "Password must contain upper case"
      // }
      else if (!numberRegex.test(value)) {
        return "Password must contain atleast one number";
      }
      else if (!symbolRegex.test(value)) {
        return "Password must contain atleast one symbol";
      }
      else if (value.length < 8) {
        return "Password must be 8 characters long";
      }
      else {
        return true;
      }
    }
    else if (type === "fullname") {

        if (fullnameRegex.test(value)) return true;
        return false;

    }
    else if (type === "lastname") {

        if (lastnameRegex.test(value)) return true;
        return false;

    }
    else if (type === "serial") {

        if (serialNumberRegex.test(value)) return true;
        return false;

    }
    else if (type === "number") {

        if (numberRegex.test(value)) return true;
        return false;

    }
    else if (type === "email") {

        if (emailRegex.test(value)) return true;
        return false;

    }
    else if (type === "phone") {

        let n = value.startsWith("+234")

        if(n === true) {
            phoneRegex = /[+^]([0-9]{9,16})$/;
        }

        if (phoneRegex.test(value)) return true;
        return false;

    }
    else if (type === "price") {

        if (priceRegex.test(value)) return true;
        return false;

    }
    else if (type === "password") {

        if (passwordRegex.test(value)) return true;
        return false;

    }
    else if (type === "otp") {

        if (otpRegex.test(value)) return true;
        return false;

    }
    else if (type === "link") {

        if (linkRegex.test(value)) return true;
        return false;

    }
    else if (type === "general") {

        if (generalRegex.test(value)) return true;
        return false;

    }
    else if (type === "business") {

        if (businessRegex.test(value)) return true;
        return false;

    }
    else if (type === "account_number") {

        if (accountNumberRegex.test(value)) return true;
        return false;

    }
    else if (type === "bvn") {

        if (bvnRegex.test(value)) return true;
        return false;

    }

};

export default validate;
